export const PARTIES_ENTITIES = "parties";
